import React, { useCallback, useEffect, useState } from 'react';
import Link from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/link';
import MarketButton from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/market-button/market-button';
import { Reference } from '@loomstateorg/shared-frontend/types/reference';

export interface Props {
  text: string;
  highlightedSubstring: string;
  target?: Reference;
  marketButtonDrawerClassName?: string;
}

const AnnouncementBar: React.FC<Props> = ({ text, highlightedSubstring, target, marketButtonDrawerClassName }) => {
  const [previewText, setPreviewText] = useState({ prefix: text, middle: '', suffix: '' });

  const processHighlighting = useCallback(() => {
    const start = text?.indexOf(highlightedSubstring);

    if (!highlightedSubstring || start === -1) {
      setPreviewText({ prefix: text, middle: '', suffix: '' });
      return;
    }

    const end = start + highlightedSubstring.length - 1;

    setPreviewText({
      prefix: text.substring(0, start),
      middle: text.substring(start, end + 1),
      suffix: text.substring(end + 1),
    });
  }, [text, highlightedSubstring]);

  useEffect(() => {
    processHighlighting();
  }, [processHighlighting]);

  return (
    <div className="relative h-32 w-full bg-primary-dark md:h-40 lg:h-44" data-testid="announcement-bar">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <p className="whitespace-nowrap text-center text-12 leading-loose text-white" data-testid="announcement-text">
          {previewText.prefix}
          <Link link={target} className="underline underline-offset-2" data-testid="announcement-cta">
            {previewText.middle}
          </Link>
          {previewText.suffix}
        </p>
      </div>

      <div className="flex size-full items-center justify-end pr-48">
        <MarketButton drawerClassName={marketButtonDrawerClassName} />
      </div>
    </div>
  );
};
export default AnnouncementBar;
